import { Link } from 'react-router-dom';

const Missing = () => {
    return (
        <article className="missing-container">
            <h1>Oops!</h1>
            <p>Page Not Found</p>
            <div className="flexGrow">
                <Link to="/" className="go-back-button">Go Back to Homepage</Link>
            </div>
        </article>
    );
};

export default Missing;
